Namespace('Customer.Views.Reports')

class Customer.Views.Reports.OperatorAvailabilityAutomaticRefreshSelectView extends Backbone.View
  template: JST['backbone/templates/customer/reports/operator_availability/operator_availability_automatic_refresh_select']
  className: 'operator-availability-refresh-select'

  initialize: ->
    @refreshTimes = new Customer.AutomaticRefreshTimeCollection(@defaultTimes())
    @selectedRefreshTime = @refreshTimes.defaultRefreshTime()
    @listenTo(Backbone, 'refresh:time:change', @updateRefreshTime)

  render: =>
    @$el.html(@template(refreshTime: @refreshTimes, selectedRefreshTime: @selectedRefreshTime))
    select = @$el.find('select').chosen(width: '220px', disable_search: true)
    select.change (event) =>
      refreshTimeID = event.target.value
      Backbone.trigger('refresh:time:change', refreshTimeID)
    @

  updateRefreshTime: (refreshTimeID) =>
    @selectedRefreshTime = @refreshTimes.getTimeByID(refreshTimeID)
    @trigger('refresh:time:update', @selectedRefreshTime)

  enable: =>
    @$el.find('select').prop('disabled', false).trigger('chosen:updated')

  disable: =>
    @$el.find('select').prop('disabled', true).trigger('chosen:updated')

  defaultTimes: =>
    [
      new Customer.AutomaticRefreshTime(
        id: "1",
        name: "thirty_seconds",
        text: "30 " + I18n.t('customer.reports.seconds'),
        value: 30000
      ),
      new Customer.AutomaticRefreshTime(
        id: "2",
        name: "one_minute",
        text: "1 " + I18n.t('customer.reports.minute'),
        value: 60000
      ),
      new Customer.AutomaticRefreshTime(
        id: "3",
        name: "two_minutes",
        text: "2 " + I18n.t('customer.reports.minutes'),
        value: 120000
      ),
      new Customer.AutomaticRefreshTime(
        id: "4",
        name: "five_minutes",
        text: "5 " + I18n.t('customer.reports.minutes'),
        value: 300000
      ),
      new Customer.AutomaticRefreshTime(
        id: "5",
        name: "ten_minutes",
        text: "10 " + I18n.t('customer.reports.minutes'),
        value: 600000
      ),
      new Customer.AutomaticRefreshTime(
        id: "6",
        name: "thirty_minutes",
        text: "30 " + I18n.t('customer.reports.minutes'),
        value: 1800000
      ),
    ]
